/* CreateNewAdhocQueryComponent.js */

"use strict";
const EventEmitter = require("events").EventEmitter;
const Renderer = require("./CreateNewAdhocQueryRenderer");

class CreateNewAdhocQueryComponent extends EventEmitter {
    constructor(logger, userSession, AdHocEntity, modalUserFeedback, parentRenderer) {
        super();
        this._titleText = "Create New Query";
        this._logger = logger;
        this._userSession = userSession;
        this._formData = AdHocEntity;
        this._modalUserFeedback = modalUserFeedback;
        this._renderer = new Renderer(this);
        this._parentRenderer = parentRenderer;
        this.reject = this.reject.bind(this);
        this.resolve = this.resolve.bind(this);

        this._registerListeners();
        this._renderer.render();
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS   */
    /*******************************************/
    _registerListeners() {}

    _unregisterListeners() {}

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS     */
    /* START PUBLIC COMPONENT MODEL METHODS    */
    /*******************************************/
    get renderer() {
        return this.getRenderer();
    }

    getRenderer() {
        return this._renderer;
    }

    get titleText() {
        return this._titleText;
    }

    get logger() {
        return this._logger;
    }

    shutdown() {
        this._unregisterListeners();
        return this._renderer.shutdown().then(
            () => {
                this._renderer = undefined;
            },
            (err) => {
                this._logger.warn({ error: err }, "CaptureNameComponent.shutdown() error");
            }
        );
    }

    cancelAction() {
        let err = new Error("user rejected");
        err.userRejected = true;
        return this.reject(err);
    }

    reject(err) {
        this._context.reject(err);
    }
    resolve(action) {
        this._context.resolve(action);
    }

    // prettier-ignore
    set "$teve.ui.context" (context) { //jshint ignore:line
        this._context = context;
    }

    /*******************************************/
    /* END COMPONENT MODEL METHODS             */
    /* START HANDLER METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE METHODS                   */
    /*******************************************/

    saveNewQuery(value) {
        this._parentRenderer
            .saveNewQuery(value, this._formData)
            .then(() => {
                this.resolve();
            })
            .catch((err) => {
                this.logger.warn(err);
                this.emit("error", err);
            });
    }

    /*******************************************/
    /* END PRIVATE METHODS                     */
    /* START PUBLIC API METHODS                */
    /*******************************************/

    /*******************************************/
    /* END PUBLIC API METHODS                  */
    /*******************************************/
}

module.exports = CreateNewAdhocQueryComponent;
